import { FC, useState } from 'react';

import Button from '@/components/button';
import Modal, { ModalActions, ModalBody, ModalText } from '@/components/modal';

interface IGenericActionModal {
	title: string;
	body: string;
	actionButtonText: string;
	onClose: () => void;
	onSubmit: () => void | Promise<void>;
}

const GenericActionModal: FC<IGenericActionModal> = ({ title, body, actionButtonText, onClose, onSubmit }) => {
	const [isActionDisabled, setIsActionDisabled] = useState(false);

	const submit = async () => {
		setIsActionDisabled(true);
		try {
			await onSubmit();
		} finally {
			setIsActionDisabled(false);
		}
	};

	return (
		<Modal title={title} onClose={onClose}>
			<ModalBody>
				<ModalText>{body}</ModalText>
				<ModalActions>
					<Button $color="primary" onClick={submit} disabled={isActionDisabled}>
						{actionButtonText}
					</Button>
				</ModalActions>
			</ModalBody>
		</Modal>
	);
};

export default GenericActionModal;
